module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAStJREFUSA1jYBgFBEKAmYA8QWkVFRV3QUHB/UJCQhLv37/fg66BIgtAhv/7928D0FBhILYGWiICtGQ7siVMyBwy2MZAPRwwff///89RVlbuhPFBNFk+gAaLzd27d6cAg+c/0BxHmKGMjIzyQF/0w/gsMAaxNFKwsAFdywi0pElJSQmkvRFo+E8gnYpsFkk+QDIcFCyMQOwHDPdH9+7dmygsLPwbyO8HWrgD2QKQIqIAmuHIev4BXZ4ENHghsiCMTVQk4zGcAWg4yOUvYQai0wR9QMBwUJgHoAcLsiV4LaDUcJBFOC2ghuE4LaCW4VgtoKbhGBZQ23CQBSjJFFpwwcsWkAIQgOZQvKkFohKTRLEAKE1Vw0HWoVuA4gRKXA4zCKcF1DAcZskojTcEAEwIj5aXSkm+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Edit.png
// module id = 662
// module chunks = 0